import { getMapNode } from "../../content/stages.js";
import type { NodeId, Screen } from "../../domain/types/index.js";
import { nodeVisualState, type NodeVisualState } from "./mapLayout.js";

const PEEK_SCREENS: readonly Screen[] = ["reward.card", "reward.organization", "rest", "event"];

type MapProgress = {
  stageId?: string;
  currentNodeId: NodeId;
  availableNodeIds: readonly NodeId[];
  clearedNodeIds: readonly NodeId[];
  activeCase?: { nodeId: NodeId } | null;
};

export function isPeekScreen(screen: Screen): boolean {
  return PEEK_SCREENS.includes(screen);
}

export function peekMapProgress(screen: Screen, run: MapProgress): MapProgress {
  if (!isPeekScreen(screen)) return run;
  const finishedId = run.activeCase?.nodeId ?? run.currentNodeId;
  const next = getMapNode(run.stageId, finishedId)?.next ?? [];
  const clearedNodeIds = run.clearedNodeIds.includes(finishedId)
    ? run.clearedNodeIds
    : [...run.clearedNodeIds, finishedId];
  return { currentNodeId: finishedId, availableNodeIds: next, clearedNodeIds };
}

export function canProceedOnMap(screen: Screen, visual: NodeVisualState): boolean {
  return screen === "map" && visual === "open";
}

export function mapNodeVisual(nodeId: NodeId, run: MapProgress, screen: Screen): NodeVisualState {
  return nodeVisualState(nodeId, peekMapProgress(screen, run));
}
